<template>
    <v-dialog max-width="600" v-model="dialog" @keydown.enter.prevent="onenter">

        <v-dialog v-model="dialog_edit" max-width="290">
            <v-card v-if="model && model.track">
                <v-card-title class="text-h5">Edit row: {{ dialog_edit_index }}</v-card-title>
                <v-text-field
                  v-if="model.track.products[dialog_edit_index]"
                  class="ma-3"
                  outlined
                  dense
                  type="number"
                  label="Points"
                  @input="validateDialogPointsInput(dialog_edit_index)"
                  v-model="model.track.products[dialog_edit_index].points"
                >
                </v-text-field>
                <r-product-dropdown
                  :model.sync="model.track.products[dialog_edit_index].product"
                  :groups="groups_product"
                  label="Product"
                  outlined
                  dense
                  class="ma-3 mt-n6"
                />
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click="dialog_edit = false">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-card v-if="model && model.track">
            <v-card-title>
                <span class="headline">Treasure Hunt Offer Bundle ({{ this.rules.name }})</span>
            </v-card-title>
            <v-card-text>

                <v-row dense class="mb-4 pt-4">
                    <v-col cols="12" md="12" sm="12">
                        <v-text-field disabled label="UID:" v-model.trim="model.uid" hide-details outlined dense/>
                    </v-col>
                    <v-text-field
                      label="Name"
                      v-model.trim="model.name"
                      class="mr-2"
                      v-ascii-only
                    />
                    <v-text-field
                      label="Key"
                      v-model.trim="model.key"
                      v-ascii-only
                    />
                </v-row>

                <v-row dense class="mt-3">
                    <v-card width="100%" class="ma-0 pa-2" elevation="0" outlined>
                        <v-card-actions width="100%" class="ma-0 pa-1" elevation="0">
                            <v-card-title class="orange--text pa-0 ma-0 ml-1">Product Track</v-card-title>
                            <v-spacer></v-spacer>
                            <v-btn icon elevation="0" color="white" dense class="green--text" @click="row_add()">
                                <v-icon>mdi-plus</v-icon>
                            </v-btn>
                        </v-card-actions>
                        <v-card-actions width="100%" class="ma-0 pa-1" elevation="0">
                            <v-data-table
                                    :headers="headers"
                                    :items="model.track.products"
                                    :height="model.track.products.length > 7 ? (32 * 7 + 32 + 16) : undefined"
                                    item-key="none"
                                    disable-pagination
                                    hide-default-footer dense
                                    style="white-space: nowrap; width: 100%;">
                                <template v-slot:item.product="{item}">
                                    {{ getProductName(item.product)}}
                                </template>
                                <template v-slot:item.points="{item}">
                                    {{ item.points }}
                                </template>
                                <template v-slot:item.actions="{item, index}">
                                    <v-icon @click="row_edit(index)" class="mr-2" small>mdi-pencil</v-icon>
                                    <v-icon @click="row_moveup(index)" class="mr-2" small>mdi-arrow-up-thick</v-icon>
                                    <v-icon @click="row_movedown(index)" class="mr-2" small>mdi-arrow-down-thick</v-icon>
                                    <v-icon @click="row_remove(index)" class="mr-2" small>mdi-delete</v-icon>
                                </template>
                            </v-data-table>
                        </v-card-actions>
                    </v-card>
                    <v-card width="100%" class="ma-0 pa-2 mt-2" elevation="0" outlined>
                        <v-card-title class="red--text pa-0 ma-0 ml-1 mb-2">Guards</v-card-title>
                        <v-expansion-panels>
                            <r-guard-panel :model.sync="model.guard" title="Guard Config"/>
                            <r-guard-money-panel :model.sync="model.guardMoney" title="Guard Money"/>
                        </v-expansion-panels>
                    </v-card>
                </v-row>

            </v-card-text>
            <v-card-actions>
                <v-spacer/>
                <v-btn @click="cancel" color="blue darken-1" text>
                    Cancel
                </v-btn>
                <v-btn @click="save" color="blue darken-1" text>
                    Save
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

import {ViewRules} from "@/common/ViewRules";
import {ProductGroupKind} from "@/modules/redactor/models/product/ProductGroupKind";
import RGuardPanel from "@/modules/redactor/views/guard/r-guard-panel.vue";
import RGuardMoneyPanel from "@/modules/redactor/views/guard/r-guard-money-panel.vue";
import RProductDropdown from "@/modules/redactor/views/product/r-product-dropdown.vue";
import {ProductTrackModel} from "@/modules/redactor/models/product/ProductTrackModel";
import {ProductTrackItemModel} from "@/modules/redactor/models/product/ProductTrackItemModel";
import {RedactorUtils} from "@/modules/redactor/core/RedactorUtils";
import {SmartOfferBundleTreasureOffer} from "@/modules/redactor/models/smart-offer/bundle-treasure-shop/SmartOfferBundleTreasureOffer";


export default {
    name: "r-smart-offer-bundle-treasure-offer",
    components: {
        RProductDropdown,
        RGuardMoneyPanel,
        RGuardPanel
    },
    data: () => ({
        dialog_edit_index: 0,
        dialog_edit: false,
        dialog: false,
        resolve: null,
        reject: null,
        tab: null,
        model: null,
        rules: ViewRules.READONLY,
        headers: [
            {text: 'Product', value: 'product'},
            {text: 'Points', value: 'points'},
            {text: '', value: 'actions', width: '100%', sortable: false, align: 'end'}
        ]
    }),
    computed: {
        groups_product() {
            return [ProductGroupKind.SMART_OFFERS]
        }
    },
    methods: {
        getProductName(uid){
            let product = RedactorUtils.getProduct(uid);
            if (product){
                return product.name;
            }
            return "-";
        },
        validateDialogPointsInput(index) {
            if (this.model.track.products.length == 0) {
                return
            }
            let value = this.model.track.products[index].points;
            value = parseInt(value);
            let number = !isNaN(value) && (function (x) {
                return (x | 0) === x;
            })(parseFloat(value))
            if (!number || value < 0) {
                this.model.track.products[index].points = 0
            }
            this.model.track.products[index].points = value
        },
        show(rules, model) {

            this.dialog = true;
            this.tab = null;
            this.rules = rules;
            this.model = model;

            if (!this.model) {
                this.model = new SmartOfferBundleTreasureOffer();
            }

            if (!this.model.track){
                this.model.track = new ProductTrackModel();
                this.model.track.products.push(new ProductTrackItemModel());
            }

            return new Promise((resolve, reject) => {
                this.resolve = resolve;
                this.reject = reject;
            });
        },
        save() {
            if (this.model.valid()) {
                this.resolve(this.model);
                this.discard();
            } else {
                this.$alert("Invalid config*!");
            }
            console.log(JSON.stringify(this.model));
        },
        cancel() {
            this.reject();
            this.discard();
        },
        discard() {
            this.dialog = false;
        },
        onenter() {
            this.save();
        },
        row_edit(index) {
            this.dialog_edit_index = index
            this.validateDialogPointsInput(index)
            this.dialog_edit = true
        },
        row_moveup(index) {
            Array.prototype.swapItems = function (a, b) {
                this[a] = this.splice(b, 1, this[a])[0];
                return this;
            }
            this.model.track.products.swapItems(index, index - 1)
            console.log(this.model.track.products)
        },
        row_movedown(index) {
            Array.prototype.swapItems = function (a, b) {
                this[a] = this.splice(b, 1, this[a])[0];
                return this;
            }
            if (index == (this.model.track.products.length - 1)) {
                this.model.track.products.swapItems(0, this.model.track.products.length - 1)
            } else {
                this.model.track.products.swapItems(index, index + 1)
            }
            console.log(this.model.track.products)
        },
        row_remove(index) {
            if (this.model.track.products.length == 1) {
                return;
            }
            this.model.track.products.splice(index, 1);
            console.log(this.model.track.products)
        },
        row_add() {
            this.model.track.products.push(new ProductTrackItemModel());
        }
    }
}
</script>
